import React, { useState } from "react";
import { Paper, Typography, Button } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import styles from "./SymbolContainer.module.css";

const SymbolContainer = () => {
  const [toogleView, setToogleView] = useState(true);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 20,
        left: 20,
      }}
    >
      {toogleView ? (
        <Paper className={styles.symbol__container}>
          <div className={styles.each__symbol__container}>
            <Button
              style={{
                background: "transparent",
              }}
              onClick={() => setToogleView(false)}
            >
              <Typography className={styles.labelText}>
                သင်္ကေတအညွှန်းများ
                <ArrowDropDownIcon />
              </Typography>
            </Button>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613888684/mmlivemap/3100327_dzcbsi.svg"
              alt=""
            />
            <Typography className={styles.labelText}>
              &nbsp;အတားအဆီးများ
            </Typography>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613717385/mmlivemap/police_twgzsr.svg"
              alt=""
            />
            <Typography className={styles.labelText}>&nbsp;ရဲ</Typography>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              alt=""
              src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613717388/mmlivemap/millitary_oqmggp.svg"
            />
            <Typography className={styles.labelText}>&nbsp;စစ်သား</Typography>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              alt=""
              src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn4.iconfinder.com%2Fdata%2Ficons%2Fhospital-and-medical-v2%2F512%2Fcross_hospital_medicine_sign_health-512.png&f=1&nofb=1"
            />
            <Typography className={styles.labelText}>&nbsp;ဆေးအဖွဲ့</Typography>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              alt=""
              src="https://res.cloudinary.com/dcx5aeaaz/image/upload/v1613888465/mmlivemap/3039889_xgizme.svg"
            />
            <Typography className={styles.labelText}>
              &nbsp;Water cannon
            </Typography>
          </div>
          <div className={styles.each__symbol__container}>
            <img
              className={styles.symbols}
              alt=""
              src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn0.iconfinder.com%2Fdata%2Ficons%2Fcommunication-material-design-icon-set%2F512%2Flocation-256.png&f=1&nofb=1"
            />
            <Typography className={styles.labelText}>
              &nbsp;အခြား (နှိပ်ကြည့်ရန်)
            </Typography>
          </div>
        </Paper>
      ) : (
        <Button
          style={{
            background: "rgba(0, 0, 0, 0.5)",
          }}
          onClick={() => setToogleView(true)}
        >
          <Typography className={styles.labelText}>
            သင်္ကေတအညွှန်းများ
            <ArrowDropUpIcon />
          </Typography>
        </Button>
      )}
    </div>
  );
};
export default SymbolContainer;
